import { IoReturnUpBackOutline } from "react-icons/io5";
import { FaRegTrashAlt } from "react-icons/fa";

import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalTitle,
  ModalDescription,
  ModalSpanDescription,
  ModalButtonsContainer,
  ModalCancelButton,
  ModalConfirmButton,
} from "./styles";

export default function CustomDeleteModal({
  show,
  intl,
  title,
  description,
  deletingFlow,
  handleClose,
  handleConfirm,
  confirmText = "confirm",
  cancelText = "goback",
}) {
  if (!show) return null;

  return (
    <ModalOverlay onClick={handleClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          {title && <ModalTitle>{title}</ModalTitle>}

          {description && (
            <ModalDescription>
              {typeof description === "string" ? description : description}
            </ModalDescription>
          )}

          <ModalButtonsContainer>
            <ModalCancelButton
              type="button"
              onClick={handleClose}
              disabled={deletingFlow}
            >
              <IoReturnUpBackOutline size={24} />
              <span>{intl.formatMessage({ id: cancelText })}</span>
            </ModalCancelButton>

            <ModalConfirmButton
              type="button"
              onClick={handleConfirm}
              disabled={deletingFlow}
            >
              <FaRegTrashAlt size={18} />
              {deletingFlow ? (
                <span>
                  {intl.formatMessage({
                    id: "CONFIRM_DELETE_FLOW_DELETING",
                  })}
                </span>
              ) : (
                <span>{intl.formatMessage({ id: confirmText })}</span>
              )}
            </ModalConfirmButton>
          </ModalButtonsContainer>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
}
